<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.27912 7.99999L6.13953 5.41883C6.82012 3.37715 8.73079 2.00002 10.8829 2.00001L13.1169 2C15.2691 1.99999
      17.1798 3.37717 17.8603 5.41892L18.7207 7.99999H18.75C20.3561 7.99999 21.6901 9.16503 21.953 10.6961C21.9835
      10.7919 22 10.8941 22 11C22 11.5523 21.5523 12 21 12C20.4477 12 20 11.5523 20 11H19.975C19.8592 10.4294 19.3547
      9.99999 18.75 9.99999H18.0259C18.0085 10.0005 17.991 10.0005 17.9737 9.99999H6.02426C6.00813 10.0004 5.99196
      10.0004 5.97576 9.99999H5.25C4.55964 9.99999 4 10.5596 4 11.25C4 11.5205 4.08772 11.7836 4.25 12L5.3 13.4C5.38682
      13.5158 5.44748 13.649 5.4778 13.7905L6.63903 19.2095C6.73783 19.6706 7.14529 20 7.61683 20H14C14.5523 20 15
      20.4477 15 21C15 21.5523 14.5523 22 14 22L13.9966 22H7.61683C6.20222 22 4.97983 21.0118 4.68342 19.6286L3.56822
      14.4243L2.65 13.2C2.22808 12.6374 2 11.9532 2 11.25C2 9.45507 3.45507 7.99999 5.25 7.99999H5.27912ZM16.6125
      7.99999L15.963 6.05135C15.5546 4.8263 14.4082 4 13.1169 4L10.8829 4.00001C9.59165 4.00001 8.44524 4.82629 8.0369
      6.0513L7.38731 7.99999H16.6125ZM10.0001 15.9999C10.0001 16.2651 10.1055 16.5195 10.293 16.707C10.4805 16.8945
      10.7349 16.9999 11.0001 16.9999H18.5901L16.7959 18.7842C16.7022 18.8772 16.6278 18.9878 16.577 19.1096C16.5262
      19.2315 16.5001 19.3622 16.5001 19.4942C16.5001 19.6262 16.5262 19.7569 16.577 19.8788C16.6278 20.0006 16.7022
      20.1112 16.7959 20.2042C16.8889 20.2979 16.9995 20.3723 17.1213 20.4231C17.2432 20.4739 17.3739 20.5 17.5059
      20.5C17.6379 20.5 17.7686 20.4739 17.8905 20.4231C18.0123 20.3723 18.1229 20.2979 18.2159 20.2042L21.7101
      16.7099C21.8011 16.6148 21.8725 16.5027 21.9201 16.3799C22.0201 16.1364 22.0201 15.8634 21.9201 15.6199C21.8725
      15.4972 21.8011 15.385 21.7101 15.2899L18.2142 11.7941C18.121 11.7009 18.0103 11.6269 17.8884 11.5764C17.7666
      11.526 17.6361 11.5 17.5042 11.5C17.3723 11.5 17.2418 11.526 17.1199 11.5764C16.9981 11.6269 16.8874 11.7009
      16.7942 11.7941C16.701 11.8873 16.627 11.998 16.5765 12.1198C16.5261 12.2417 16.5001 12.3722 16.5001
      12.5041C16.5001 12.636 16.5261 12.7665 16.5765 12.8883C16.627 13.0102 16.701 13.1209 16.7942 13.2141L18.5901
      14.9999H11.0001C10.7349 14.9999 10.4805 15.1053 10.293 15.2928C10.1055 15.4803 10.0001 15.7347 10.0001 15.9999Z"
      fill="currentColor"
    />
  </svg>
</template>
